import { formatFieldName } from 'primsell-shared-layer/helpers'
import { MessageParams } from 'yup/lib/types'

export const fieldsValidation = {
  INVALID_EMAIL: 'Invalid email address provided, please try again.',
  REQUIRED: (fieldOptions: MessageParams): string => `${formatFieldName(fieldOptions.path)} is required`,
  PASSWORD_CONFIRM: 'Passwords should match, please try again',
}
